export const CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const SHARDS = 16;

export function newCode(len = 5, random: () => number = Math.random): string {
  let out = '';
  for (let i = 0; i < len; i++) out += CODE_ALPHABET[Math.floor(random() * CODE_ALPHABET.length)];
  return out;
}

export function isValidCode(s: string): boolean {
  if (typeof s !== 'string' || s.length !== 5) return false;
  const up = s.toUpperCase();
  for (const c of up) if (!CODE_ALPHABET.includes(c)) return false;
  return true;
}

/** FNV-1a over the id, reduced to a shard number. Deterministic across runtimes. */
export function shardOf(playerId: string, shards = SHARDS): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < playerId.length; i++) {
    h ^= playerId.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h % shards;
}
